"use client";

import { useDateFormatter } from "react-aria";

import { type TourProps } from "~/lib/fragments";
import { useCart, type TourCartLine } from "~/lib/use-cart";
import { useCurrencyFormatter } from "~/lib/use-currency";

export function CartItineraryTour({
  tour,
  datoDayId,
  date,
}: {
  tour: TourProps;
  datoDayId: string;
  date: Date;
}) {
  const cart = useCart().cart;
  const formatCurrency = useCurrencyFormatter();
  const formatDate = useDateFormatter({
    timeZone: "UTC",
    day: "numeric",
    month: "short",
  });

  let cartLine: TourCartLine | null = null;

  if (cart) {
    for (const c of cart.cartLines) {
      if (
        c.type !== "trip" &&
        c.lineItem.datoDayId === datoDayId &&
        c.lineItem.datoTourId === tour.id
      ) {
        cartLine = c;
      }
    }
  }
  if (!cartLine) {
    return null;
  }
  const formattedAmount = cartLine.amount ? formatCurrency(cartLine.amount) : 0;
  return (
    <div className="line-clamp-1">
      {formattedAmount} - {formatDate.format(date)} - {tour.title}
    </div>
  );
}
